<template>
  <!-- eslint-disable -->
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="14.5" fill="#F9F7ED" stroke="#205441"/>
    <mask id="mask0_85_1724" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="6" y="6" width="18" height="18">
      <rect x="6" y="6" width="18" height="18" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_85_1724)">
      <path d="M10.7254 20.7002L9.33789 19.2752L13.5941 15.0002L9.33789 10.6877L10.7254 9.2627L15.0191 13.5752L19.2754 9.2627L20.6629 10.6877L16.4066 15.0002L20.6629 19.2752L19.2754 20.7002L15.0191 16.3877L10.7254 20.7002Z" fill="#205441"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'XSvg',
};
</script>

<style lang="scss" scoped>
</style>
